import React, { FC } from 'react'
import { Page } from '@moonpig/web-core-app'
import { Container } from '@moonpig/launchpad-components'
import Head from 'next/head'
import { Routes } from '@moonpig/web-core-routing'
import { Region } from '@moonpig/web-core-types'
import { ForgottenPassword } from '../../components/ForgottenPassword'
import { useAccountLocaleText } from '../../text-localisation'

type PageProps = {
  region: Region
  invalidToken: boolean
}

export const ForgottenPasswordPage: Page<
  PageProps,
  Routes['forgotten-password']
> = ({ region, invalidToken }) => {
  return (
    <ForgottenPasswordPageContent region={region} invalidToken={invalidToken} />
  )
}

const ForgottenPasswordPageContent: FC<PageProps> = ({
  region,
  invalidToken,
}) => {
  return (
    <>
      <Head>
        <title>{useAccountLocaleText()('forgotten_password.page_title')}</title>
      </Head>
      <Container limitWidth>
        <ForgottenPassword region={region} invalidToken={invalidToken} />
      </Container>
    </>
  )
}

ForgottenPasswordPage.layout = 'default'

ForgottenPasswordPage.getInitialProps = async (context): Promise<PageProps> => {
  const invalidToken = context.query['invalid-token']
  return {
    region: context.region,
    invalidToken: !!invalidToken,
  }
}
